import {Injectable, Optional} from "@angular/core";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {KeycloakAuthGuard, KeycloakService} from "keycloak-angular";
import {environment} from "../../environments/environment";
import {AuthService} from "../services/auth/auth-service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
    providedIn: "root",
})
export class AuthGuardKeycloak extends KeycloakAuthGuard {
    constructor(
        protected readonly router: Router,
        private translate: TranslateService,
        @Optional() protected readonly keycloak: KeycloakService,
    ) {
        super(router, keycloak);
    }

    // @ts-ignore
    public async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        // Force the user to log in if currently unauthenticated.
        if (!this.authenticated) {
            return await this.keycloak.login({
                redirectUri: window.location.origin + state.url,
                locale: this.translate.currentLang,
            });
        }

        if (this.keycloak.isUserInRole(AuthService.neededRole, environment.OAUTH_CLIENT_ID)) {
            return Promise.resolve(true);
        }
        return this.keycloak.logout(window.location.origin + "/login?error=bpa.no.rights");
    }
}
